import React, { Component } from 'react';
import {Button} from 'antd';
import { Link } from 'react-router-dom';
import {burritoAPIs} from '../../apiCalls/index'
import axios from 'axios';

import {Configs} from '../../dashboard/api';

class Home extends Component{
    constructor(props){
        super(props);
        this.state={
            text :'Order from our Burrito Bar '
        }
        
    }
    async generateSessionID(){
        var responsevar = await burritoAPIs.generateSessionID();
        console.log('responsevar',responsevar)
        if(responsevar){
            localStorage.setItem('sessionID', responsevar.sessionid);
            this.props.history.push({
                pathname: '/menu'              
            });
          }
    }


    async getLocationID(){
        var responsevar = await burritoAPIs.getLocationID();
        console.log('responsevar',responsevar.location[0]._id)
        if(responsevar){
            localStorage.setItem('locationID', responsevar.location[0]._id);
            this.props.history.push({
                pathname: '/menu'              
            });
          }
    }
    componentDidMount(){

    const dataID = async() =>{

        try {
        const result = await axios.get(Configs.banners)
           this.setState( {text : result.data.banners[0].name})
        // console.log(result.data.banners[0].name)
      }
        catch (error) {
          console.log(error.message);
      }
      }
      dataID();
    }

    render(){
        return(
            <React.Fragment>
                <div className='home'>
                <div className='home-text'>
                <div className='marker-text'>
                Hungry?
                </div>
                <div className='home-para'>
                {this.state.text}
                </div>
              
                </div>               
                <Button
                style={{position:'absolute', bottom:'50px'}}
                onClick={() => {this.generateSessionID(); this.getLocationID()}}
                className='place-order'>
                Place Order
                </Button>
               

                </div>
            </React.Fragment>

        );
    }
}
export default Home;